import React, { useContext, useState } from 'react';
import { NavLink, BrowserRouter as Router, useHistory } from 'react-router-dom';
import { Header } from '@accesa/react-core/build/layout/header';
import { Button } from '@accesa/react-core/build/form/button';

import CancelModal from '../TaskView/CancelModal';
import { AppContext } from '../../AppContext';

import useConstLang from './lang';
import S from './styled';

const AppHeader: React.FC = (): React.ReactElement => {
  const { userDisplayName } = useContext(AppContext);
  const T = useConstLang();

  const [isCancelModalOpen, triggerCancelModal] = useState<boolean>(false);

  function handleModalTrigger(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault();
    window.location.pathname.match(/.*(add|edit).*/)
      ? triggerCancelModal(true)
      : goToDashboard();
  };

  function goToDashboard() {
    window.location.href = '/dashboard/list';
  };

  function doLogout() {
    window.location.href = '/logout';
  }

  return (
    <S.StyledHeader>
      <CancelModal
        isModalOpen={isCancelModalOpen}
        goBackHandler={goToDashboard}
        triggerModal={triggerCancelModal}
        text={T.cancelWarning}
      />

      <Header
        appTitle={T.siteTitle}
        userName={userDisplayName && userDisplayName}
        headerLink={
          <Button
            onClick={() => doLogout()}
            text={T.logoutButtonText}
            appearance={'primary'}
            isDismiss={true}
          />
        }
        menu={
          <S.LinksContainer>
            <Router>
              <NavLink
                exact
                to="/dashboard/list"
                activeStyle={{ borderBottom: '2px solid #ff6600' }}
                onClick={handleModalTrigger}
              >
                Dashboard
              </NavLink>
            </Router>
          </S.LinksContainer>
        }
      />
    </S.StyledHeader>
  );
};

export default AppHeader;
